<div class="col-xs-12">
  <div class="row">
    <div style="height:50px;cursor: pointer;" class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center" id="accountTab" (click)="toggleTopBar('accountTab')">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:14px"> Account Incentive Rules</label>
    </div>
    <div style="height:50px;cursor: pointer;" class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center" id="userTypeTab" (click)="toggleTopBar('userTypeTab');">
      <label style=" cursor: pointer;color:#FFFFFF;margin-top:14px"> User Type Incentive Rules</label>
    </div>
  </div>
</div>
<div class="tile-progress bg-white text-left col-lg-12" *ngIf="selectedTab=='accountTab'">
  <div class="col-lg-4" style="padding-left: 0;">
    <label>Select Account</label>
    <ng-select [items]="accounts" (change)="getIncentiveConfigByAccountId()" name="accounts" bindLabel="accountName"
      [clearable]="true" [searchable]="true" bindValue="accountId" [(ngModel)]="accountId" placeholder="Select Account">
    </ng-select>
  </div>
</div>
<div class="tile-progress bg-white text-left col-lg-12" *ngIf="selectedTab=='userTypeTab'">
  <div class="col-lg-4" style="padding-left: 0;">
    <label>Select User Type</label>
    <ng-select [items]="userTypes" (change)="getIncentiveConfigByUserType()" name="userTypes" bindLabel="name"
      [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="userTypeId" placeholder="Select User Type">
    </ng-select>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:0px;padding-right:0px"
  *ngIf="(selectedTab=='accountTab' && accountId!=null && accountId>0) || (selectedTab=='userTypeTab' && userTypeId!=null)">
  <div class="card-header">
    Incentive & Referral Eligibility
  </div>
  <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
    <div class="row">
      <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <label class="form-label">Is Incentive Scheme Available?
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc"></span>
        <div class="controls">
          <div class="chiller_cb">
            <div class="chiller_cb">
              <input id="isincentiveavailable" [(ngModel)]="incentiveConfig.isIncentiveSchemeAvailable"
                name="isincentiveavailable" type="checkbox" />
              <label style="font-weight: normal;" for="isincentiveavailable">Select if incentive scheme
                available</label>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="incentiveConfig.isIncentiveSchemeAvailable">
        <label class="form-label">No Of Refraction Units
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc">Refractions to be used for Incentive Plan</span>
        <div class="controls">
          <input type="number" [(ngModel)]="incentiveConfig.incentiveEligibility.refractionUnitUsage"
            class="form-control" min=0 #refusageforeligibility="ngModel" id="refusageforeligibility"
            name="refusageforeligibility" placeholder="Refractions to be used for Incentive Plan" />
        </div>
      </div> -->
      <!-- <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="incentiveConfig.isIncentiveSchemeAvailable">
        <label class="form-label">Required to complete in specific duration?
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc"></span>
        <div class="controls">
          <div class="chiller_cb">
            <div class="chiller_cb">
              <input id="restrictedduration" [(ngModel)]="incentiveConfig.incentiveEligibility.hasRestrictedDuration"
                name="restrictedduration" type="checkbox" />
              <label style="font-weight: normal;" for="restrictedduration">Select if refractions to be used</label>
              <span></span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6"
        *ngIf="incentiveConfig.isIncentiveSchemeAvailable && incentiveConfig.incentiveEligibility.hasRestrictedDuration">
        <label class="form-label">No Of Days
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc">Number of days given</span>
        <div class="controls">
          <input type="number" [(ngModel)]="incentiveConfig.incentiveEligibility.refractionUnitUsageInDays"
            class="form-control" min=0 #refusageindays="ngModel" id="refusageindays" name="refusageindays"
            placeholder="Refractions to be used in days" />
        </div>
      </div> -->
      <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <label class="form-label">Is Referral Scheme Available?
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc"></span>
        <div class="controls">
          <div class="chiller_cb">
            <div class="chiller_cb">
              <input id="isreferralavailable" [(ngModel)]="incentiveConfig.isReferralSchemeAvailable"
                name="isreferralavailable" type="checkbox" />
              <label style="font-weight: normal;" for="isreferralavailable">Select if referral scheme available</label>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="incentiveConfig.isReferralSchemeAvailable">
        <label class="form-label">No Of Prescriptions
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc">No Of Prescriptions for Referral Eligibility</span>
        <div class="controls">
          <input type="number" [(ngModel)]="incentiveConfig.eligibilityForReferral.refractionUnitToBeUsed"
            class="form-control" min=0 #referraleligibility="ngModel" id="referraleligibility"
            name="referraleligibility" placeholder="Prescriptions to be generated for referral" />
        </div>
      </div>
      <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="incentiveConfig.isReferralSchemeAvailable">
        <label class="form-label">Max Referral Count
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc">Max users can be referred by single user</span>
        <div class="controls">
          <input type="number" [(ngModel)]="incentiveConfig.eligibilityForReferral.maxUserReferral" class="form-control"
            min=0 #maxreferral="ngModel" id="maxreferral" name="maxreferral" placeholder="Max Referral Count" />
        </div>
      </div>
      <!-- <div class="form-group col-xs-12 col-sm-12 col-md-6 col-lg-6" *ngIf="incentiveConfig.isReferralSchemeAvailable">
        <label class="form-label">Max Referral Bonus
          <span class="mandatory-symbol">*</span>
        </label>
        <span class="desc">Max referral bonus can be earned by single user</span>
        <div class="controls">
          <input type="number" [(ngModel)]="incentiveConfig.eligibilityForReferral.maxReferralRechargeBonus"
            class="form-control" min=0 #maxreferralbonus="ngModel" id="maxreferralbonus" name="maxreferralbonus"
            placeholder="Max Referral Bonus" />
        </div>
      </div> -->
    </div>
  </div>
</div>

<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " style="padding-left:0px;padding-right:0px"
  *ngIf="((selectedTab=='accountTab' && accountId!=null && accountId>0) || (selectedTab=='userTypeTab' && userTypeId!=null)) && (incentiveConfig.isIncentiveSchemeAvailable || incentiveConfig.isReferralSchemeAvailable)">
  <div class="card-header">
    Incentive Rules
    <button class="btn btn-sm btn-primary float-right"
      style="margin-top: -4px;margin-left: 4px;background-color:rgb(87,200,231)" (click)="addNewRow()">
      <span>
        <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> Add New Incentive Rule</span>
    </button>
  </div>

  <div class="content-body padding-top-20 padding-bottom-20" style="padding-bottom: 0px !important;">
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12" style="padding-left: 0px;padding-right: 0px;">
        <table class="table table-border-yellow">
          <tbody>
            <tr *ngFor="let config of incentiveConfig.config; let i=index">
              <td style="width: 50px;vertical-align: middle;" [ngClass]="{'border-top-none' : i==0}">
                {{i+1}}
              </td>
              <td class="form-group" [ngClass]="{'border-top-none' : i==0}"
                style="padding-left: 0px;padding-right: 0px;">
                <div class="row">
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                    <select [(ngModel)]="config.incentiveCategory" required class="form-select form-select-sm"
                      #incentivecategory{{i}}="ngModel" id="incentivecategory{{i}}" name="incentivecategory{{i}}">
                      <option *ngFor="let category of incentiveCategories" [ngValue]="category.id">{{category.value}}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3">
                    <input type="text" [(ngModel)]="config.incentiveRuleName" [disabled]="config.id!=null"
                      (blur)="updateTermsAndConditions()" class="form-control" #rulename{{i}}="ngModel"
                      id="rulename{{i}}" name="rulename{{i}}" placeholder="Rule Name" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE' || config.incentiveCategory=='ON_RECHARGE'">
                    <div class="chiller_cb">
                      <input id="forreferreduser{{i}}" [(ngModel)]="config.onlyForReferredUser"
                        name="forreferreduser{{i}}" type="checkbox" class="form-control" />
                      <label style="font-weight: normal;" for="forreferreduser{{i}}">Only For Referred User?</label>
                      <span></span>
                    </div>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE'">
                    <select [(ngModel)]="config.rechargeType" class="form-select form-select-sm" #rechargetype{{i}}="ngModel"
                      id="rechargetype{{i}}" name="rechargetype{{i}}">
                      <option value="UNIT">Based on Refraction Unit</option>
                      <option value="VALUE">Based on Recharge Value</option>
                    </select>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_SIGNUP'">
                    <input type="number" [(ngModel)]="config.refractionCreditUnit" class="form-control" min=0
                      #refcreditunit{{i}}="ngModel" id="refcreditunit{{i}}" name="refcreditunit{{i}}"
                      placeholder="Free Refraction Credit Unit" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_SIGNUP'">
                    <input type="number" [(ngModel)]="config.validityInDays" class="form-control" min=0
                      #refcreditunit{{i}}="ngModel" id="refcreditunit{{i}}" name="refcreditunit{{i}}"
                      placeholder="Validity (in days)" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE' || config.incentiveCategory=='RECHARGE_ELIGIBILITY'">
                    <input type="number" [(ngModel)]="config.refractionUsageInUnit" class="form-control" min=0
                      #refusageunit{{i}}="ngModel" id="refusageunit{{i}}" name="refusageunit{{i}}"
                      placeholder="Refraction Usage In Unit" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE'">
                    <input type="number" [(ngModel)]="config.refractionUsageInDays" class="form-control" min=0
                      #refusagedays{{i}}="ngModel" id="refusagedays{{i}}" name="refusagedays{{i}}"
                      placeholder="Target In Days" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE'">
                    <div class="chiller_cb">
                      <input id="includesfreecredits{{i}}" [(ngModel)]="config.refractionUseIncludesFreeCredits"
                        name="includesfreecredits{{i}}" type="checkbox" class="form-control" />
                      <label style="font-weight: normal;" for="includesfreecredits{{i}}">Includes Free Credits?</label>
                      <span></span>
                    </div>
                  </div>
                  <!-- <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE'">
                    <input type="number" [(ngModel)]="config.freeRefractionsToBeUsed" class="form-control" min=0
                      #freereftobeused{{i}}="ngModel" id="freereftobeused{{i}}" name="freereftobeused{{i}}"
                      placeholder="Refraction Usage Unit" />
                  </div> -->
                  <!-- <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_REFRACTION_USE'">
                    <input type="number" [(ngModel)]="config.amountCreditToReferrer" class="form-control" min=0
                      #bonustoreferrer{{i}}="ngModel" id="bonustoreferrer{{i}}" name="bonustoreferrer{{i}}"
                      placeholder="Bonus Amount to Referrer" />
                  </div> -->
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' && config.rechargeType=='UNIT'">
                    <input type="number" [(ngModel)]="config.minRefractionRechargeUnit" class="form-control" min=0
                      #minrefrecharge{{i}}="ngModel" id="minrefrecharge{{i}}" name="minrefrecharge{{i}}"
                      placeholder="Min Refraction Unit" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' && config.rechargeType=='UNIT'">
                    <input type="number" [(ngModel)]="config.maxRefractionRechargeUnit" class="form-control" min=0
                      #maxrefrecharge{{i}}="ngModel" id="maxrefrecharge{{i}}" name="maxrefrecharge{{i}}"
                      placeholder="Max Refraction Unit" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' && config.rechargeType=='VALUE'">
                    <input type="number" [(ngModel)]="config.minRefractionRechargeCredit" class="form-control" min=0
                      #minrefrechargeunit{{i}}="ngModel" id="minrefrechargeunit{{i}}" name="minrefrechargeunit{{i}}"
                      placeholder="Min Recharge Value" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' && config.rechargeType=='VALUE'">
                    <input type="number" [(ngModel)]="config.maxRefractionRechargeCredit" class="form-control" min=0
                      #maxrefrechargeunit{{i}}="ngModel" id="maxrefrechargeunit{{i}}" name="maxrefrechargeunit{{i}}"
                      placeholder="Max Recharge Value" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3" *ngIf="config.incentiveCategory=='ON_RECHARGE' && 
                  (config.rechargeType=='UNIT' || config.rechargeType=='VALUE') 
                    && !config.isConditionOnly">
                    <select [(ngModel)]="config.payoutType" class="form-select form-select-sm" #payouttype{{i}}="ngModel"
                      id="payouttype{{i}}" name="payouttype{{i}}">
                      <option value="FLAT">Flat</option>
                      <option value="PERCENTAGE">Percentage</option>
                    </select>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory!='ON_SIGNUP' && config.incentiveCategory!='RECHARGE_ELIGIBILITY'">
                    <div class="chiller_cb">
                      <input id="conditiononly{{i}}" [(ngModel)]="config.isConditionOnly" name="conditiononly{{i}}"
                        type="checkbox" class="form-control" />
                      <label style="font-weight: normal;" for="conditiononly{{i}}">Only Condition?</label>
                      <span></span>
                    </div>
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3" *ngIf="(config.incentiveCategory=='ON_REFRACTION_USE' || config.incentiveCategory=='ON_SIGNUP'
                   || config.incentiveCategory=='ON_RECHARGE') 
                    && !config.onlyForReferredUser && !config.isConditionOnly">
                    <input type="number" [(ngModel)]="config.payoutToUser" class="form-control" min=0
                      #payouttouser{{i}}="ngModel" id="payouttouser{{i}}" name="payouttouser{{i}}"
                      placeholder="Payout to User" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3" *ngIf="(config.incentiveCategory=='ON_REFRACTION_USE' || config.incentiveCategory=='ON_RECHARGE')
                     && config.onlyForReferredUser  && !config.isConditionOnly">
                    <input type="number" [(ngModel)]="config.payoutToReferredUser" class="form-control" min=0
                      #payouttoreferreduser{{i}}="ngModel" id="payouttoreferreduser{{i}}"
                      name="payouttoreferreduser{{i}}" placeholder="Payout to Referred User" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' && config.payoutType=='PERCENTAGE' && !config.isConditionOnly">
                    <input type="number" [(ngModel)]="config.maxPayoutAmount" class="form-control" min=0
                      #maxpayoutamount{{i}}="ngModel" id="maxpayoutamount{{i}}" name="maxpayoutamount{{i}}"
                      placeholder="Max Payout Amount" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory!=null && config.incentiveCategory!='RECHARGE_ELIGIBILITY' && !config.isConditionOnly">
                    <input type="text" [(ngModel)]="config.addtionalBenefits" class="form-control"
                      #additionalbenefits{{i}}="ngModel" id="additionalbenefits{{i}}" name="additionalbenefits{{i}}"
                      placeholder="Additional Benefits" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                    *ngIf="config.incentiveCategory=='ON_RECHARGE' || 
                    (config.incentiveCategory=='ON_REFRACTION_USE' && config.onlyForReferredUser) && !config.isConditionOnly">
                    <input type="text" [(ngModel)]="config.numberOfTimes" class="form-control"
                      #numberoftimes{{i}}="ngModel" id="numberoftimes{{i}}" name="numberoftimes{{i}}"
                      placeholder="Number Of Times" />
                  </div>
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="termsAndConditionRules!=null && termsAndConditionRules.length>0 && config.incentiveCategory!='ON_SIGNUP' &&
                    config.incentiveCategory!='RECHARGE_ELIGIBILITY'
                     && !config.isConditionOnly">
                    <ng-select [items]="termsAndConditionRules" class="custom-ng-select" bindLabel="value"
                      multiple="true" [clearable]="true" style="border:none;border-bottom: 1px solid #e8e8e8;"
                      [searchable]="true" bindValue="id" [(ngModel)]="config.termsAndConditions"
                      placeholder="Select Terms & Conditions">
                    </ng-select>
                  </div>
                </div>
              </td>
              <td class="form-group" [ngClass]="{'border-top-none' : i==0}">
                <span class="fa fa-trash" *ngIf="config.status"
                  style="color: rgb(98,52,18);font-size: 20px;cursor: pointer;" (click)="removeRow(i)"></span>
                <span class="fa fa-undo" *ngIf="!config.status"
                  style="color: darkorange;font-size: 20px;cursor: pointer;" (click)="removeRow(i)"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="incentiveConfig.config!=null && incentiveConfig.config.length>0 && (incentiveConfig.isIncentiveSchemeAvailable || incentiveConfig.isReferralSchemeAvailable)"> -->
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" *ngIf="incentiveConfig.isIncentiveSchemeAvailable || incentiveConfig.isReferralSchemeAvailable">
        <div class="col-xs-12 text-center mBottom15">
          <button style="margin-right: 5px;" class="btn btn-sm btn-success marginLR5" (click)="saveIncentiveConfig()">
            <i class="fa fa-fw fa-lg fa-check-circle"></i> Save Incentive Config</button>
        </div>
      </div>
    </div>
  </div>

</div>